import {
  Action,
  ActionType,
  IGetClassFilterResponse,
} from "models/messagemanagement/classFilterList";
import createReducer from "../../createReducer";

export interface GetClassListFilterReducerType {
  loading: boolean;
  error?: string;
  classFilterListResponse?: IGetClassFilterResponse;
}

const defaultState: GetClassListFilterReducerType = {
  loading: false,
  error: undefined,
  classFilterListResponse: undefined,
};

export const classListFilterReducer =
  createReducer<GetClassListFilterReducerType>(defaultState, {
    [ActionType.GET_CLASS_LIST_FILTER](state: GetClassListFilterReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.GET_CLASS_LIST_FILTER_ERROR](
      state: GetClassListFilterReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.GET_CLASS_LIST_FILTER_SUCCESS](
      state: GetClassListFilterReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        classFilterListResponse: action.payload,
      };
    },
  });
